import { H2RInput } from "../../imports";
import { H2RCheckbox } from "../../imports";
import { H2RSelect } from "../../imports";
import { imageTypesDefinitions } from "../../imports";
import { ImagePreview } from "../FormElements";
import { ReplaceWithDataSource } from "../helpers/variable";

export const GraphicEditor = ({ cue, media, onUpdate }) => {
	return (
		<>
			<H2RInput
				label="Chat content (Large text)"
				value={cue.chat.snippet.displayMessage || ""}
				onChange={(value) => {
					onUpdate({
						chat: {
							...cue.chat,
							snippet: {
								...cue.chat.snippet,
								displayMessage: value,
							},
						},
					});
				}}
			/>
			<H2RInput
				label="Chat author (Small text)"
				value={cue.chat.authorDetails.displayName || ""}
				onChange={(value) => {
					onUpdate({
						chat: {
							...cue.chat,
							authorDetails: {
								...cue.chat.authorDetails,
								displayName: value,
							},
						},
					});
				}}
			/>
			<H2RCheckbox
				checked={cue.useCustomImage || false}
				label="Custom author image"
				hint={cue.useCustomImage && "Tip: Use a square image for best results."}
				checkboxLabel={
					cue.useCustomImage ? "Yes, use custom image" : "No, use default image"
				}
				onChange={(change) => {
					onUpdate({ useCustomImage: change });
				}}
			/>
			{cue.useCustomImage && (
				<>
					<H2RSelect
						selected={cue.customImage}
						label="Author image"
						options={
							media.length === 0
								? [
										{
											label: "Add images in the Media tab",
											value: ``,
											disabled: true,
										},
								  ]
								: [
										...media
											.filter((item) =>
												imageTypesDefinitions.includes(item.mimetype)
											)
											.filter((item) => !item.partOf)
											.map((item) => {
												return {
													label: item.originalname,
													value: item.filename,
												};
											}),
								  ]
						}
						onChange={(value) => {
							return onUpdate({ customImage: value });
						}}
					/>
					<ImagePreview image={cue.customImage} />
				</>
			)}
			<H2RCheckbox
				checked={cue.chat?.snippet?.type === "superChatEvent" ? true : false}
				label="Sponsored"
				checkboxLabel="Sponsored"
				onChange={(change) => {
					console.log(cue.chat);
					if (change === true) {
						onUpdate({
							chat: {
								...cue.chat,
								snippet: {
									...cue.chat.snippet,
									type: "superChatEvent",
								},
							},
						});
					} else {
						onUpdate({
							chat: {
								...cue.chat,
								snippet: {
									...cue.chat.snippet,
									type: "textMessage",
								},
							},
						});
					}
				}}
			/>
			<H2RSelect
				selected={cue.sponsoredCelebration || "none"}
				label="Celebration"
				options={[
					{
						label: "None",
						value: "none",
					},
					{
						label: "Balloons",
						value: "balloons",
					},
					{
						label: "Confetti",
						value: "confetti",
					},
					{
						label: "Money",
						value: "money",
					},
					{
						label: "Emoji",
						value: "emoji",
					},
				]}
				onChange={(value) => {
					return onUpdate({ sponsoredCelebration: value });
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis w-48 md:w-full max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">
				{(
					<ReplaceWithDataSource
						text={cue.chat?.authorDetails?.displayName}
						keepBrakets={true}
					/>
				) || "Chat message"}
			</span>
			<span className="pl-2 text-xs text-gray-300">
				{
					<ReplaceWithDataSource
						text={cue.chat?.snippet?.displayMessage}
						keepBrakets={true}
					/>
				}
			</span>
		</div>
	);
};
